import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { Form, Input, DatePicker } from 'antd';
import FileUpload from 'components/form/FileUploadPrivate';
import SectionHeader from '../../components/SectionHeader';
import InfoTip from '../../components/InfoTip';
import MoneyInput from '../../components/MoneyInput';
import MalpracticeExpiryNotice from '../../components/MalpracticeExpiryNotice';
import { CARRIERS } from '../../constants';
import s from '../../s.module.less';

export default function StepMalpractice() {
    const form = Form.useFormInstance();
    // carrier 直接存接口字段：选预设写入具体名称，选 Other 时清空并由输入框直接写 carrier
    const carrier = Form.useWatch('carrier', form);
    const expireDate = Form.useWatch('expireDate', form);
    const [isOther, setIsOther] = useState(false);
    useEffect(() => {
        if (carrier && !CARRIERS.includes(carrier)) setIsOther(true);
    }, [carrier]);

    return (
        <div className={s.wizSection}>
            <SectionHeader title="Malpractice insurance certificate" />
            {/* 标签 → chips →（选 Other 时）输入框在下方；carrier 值存于同一个 Form.Item，
                非 Other 时该项 hidden（不占位、不显示空框），对齐原型 cred-carrier-other-wrap */}
            <div className={s.carrierField}>
                <div className={s.carrierLabel}>Malpractice insurance carrier</div>
                <div className={s.carrierChips}>
                    {CARRIERS.map((c) => {
                        const isOtherChip = c === 'Other';
                        const selected = isOtherChip ? isOther : !isOther && carrier === c;
                        return (
                            <button
                                key={c}
                                type="button"
                                className={cx(s.carrierChip, selected && s.selected)}
                                onClick={() => {
                                    if (isOtherChip) {
                                        setIsOther(true);
                                        form.setFieldValue('carrier', '');
                                    } else {
                                        setIsOther(false);
                                        form.setFieldValue('carrier', c);
                                        form.validateFields(['carrier']);
                                    }
                                }}
                            >
                                {c}
                            </button>
                        );
                    })}
                </div>
                <Form.Item
                    name="carrier"
                    rules={[{ required: true, message: isOther ? 'Enter carrier name' : 'Select a carrier' }]}
                    hidden={!isOther}
                    style={{ marginBottom: 0 }}
                >
                    <Input size="large" placeholder="Enter carrier name" />
                </Form.Item>
            </div>
            <Form.Item
                name="licenseNumber"
                label="Policy / certificate number"
                rules={[{ required: true, message: 'Required' }]}
            >
                <Input size="large" placeholder="Certificate number" />
            </Form.Item>
            <div className={s.wizRow}>
                <Form.Item
                    name="effectiveDate"
                    label="Effective date"
                    rules={[{ required: true, message: 'Required' }]}
                >
                    <DatePicker size="large" style={{ width: '100%' }} />
                </Form.Item>
                <Form.Item name="expireDate" label="Expiration date" rules={[{ required: true, message: 'Required' }]}>
                    <DatePicker size="large" style={{ width: '100%' }} />
                </Form.Item>
            </div>
            <MalpracticeExpiryNotice expireDate={expireDate} />
            <div className={s.wizRow}>
                <Form.Item
                    name="perOccurrenceCents"
                    label={
                        <span>
                            Per-occurrence limit
                            <InfoTip title="The most an insurer will pay for a single claim. Most payers require at least $1M." />
                        </span>
                    }
                    rules={[{ required: true, message: 'Required' }]}
                >
                    <MoneyInput placeholder="e.g. $1,000,000" />
                </Form.Item>
                <Form.Item
                    name="aggregateCents"
                    label={
                        <span>
                            Aggregate limit
                            <InfoTip title="The most an insurer will pay in total across all claims in a policy period. Most payers require at least $3M." />
                        </span>
                    }
                    rules={[{ required: true, message: 'Required' }]}
                >
                    <MoneyInput placeholder="e.g. $3,000,000" />
                </Form.Item>
            </div>
            <div>
                <p className={s.uploadLabel}>
                    Certificate copy
                    <InfoTip title="A certificate of insurance from your malpractice carrier (e.g. HPSO, NSO, CM&F). It shows your coverage limits and policy dates." />
                </p>
                {/* 只在 Review 提交时由 setFields 标红（未触碰不校验），补传后 onChange 自动清除 */}
                <Form.Item
                    name="url"
                    rules={[{ required: true, message: 'Upload your certificate of insurance (COI)' }]}
                >
                    <FileUpload uploadType="LICENSE" accept=".pdf,.jpg,.jpeg,.png" />
                </Form.Item>
            </div>
        </div>
    );
}
